import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    OnChanges,
    SimpleChanges,
    ViewChild,
    Output,
    EventEmitter,
    NgZone,
    ElementRef,
    OnDestroy,
    signal,
    computed,
    inject,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { S25PipesModule } from "../../../../../../pipes/s25.pipes.module";
import { S25CheckboxModule } from "../../../../../s25-checkbox/s25.checkbox.module";
import { S25DeleteModule } from "../../../../../s25-delete/s25.delete.module";
import { S25EditableModule } from "../../../../../s25-editable/s25.editable.module";
import { S25IconComponent } from "../../../../../s25-icon/s25.icon.component";
import { S25ItemComponent } from "../../../../../s25-item/s25.item.component";
import { S25LoadingInlineModule } from "../../../../../s25-loading/s25.loading.inline.module";
import { S25ModalModule } from "../../../../../s25-modal/s25.modal.module";
import { S25ObjectSearchModule } from "../../../../../s25-object-search/s25.object.search.module";
import { S25SliderModule } from "../../../../../s25-slider/s25.slider.module";
import { S25ToggleButtonModule } from "../../../../../s25-toggle-button/s25.toggle.button.module";
import { S25ReservationUtil } from "../../../../utils/s25.reservation.util";
import { EventDataMicroI, S25Event } from "../../../../EventMicroI";
import { S25Util } from "../../../../../../util/s25-util";
import { OccurrenceTimeRangeLabels } from "../../../../../../util/occurrence.time.colors";
import { CopyOccTarget, EventOccUtil } from "../../s25.event.occurrence.util";
import { Range } from "../../../../../s25-slider/s25.slider.component";
import { S25EventOccurrencesService } from "../../../s25.event.occurrences.service";
import { Debounce } from "../../../../../../decorators/debounce.decorator";
import { S25LoadingApi } from "../../../../../s25-loading/loading.api";
import { EventMicroService } from "../../../../../../services/event.micro.service";
import { S25Reservation, S25RsReservation, S25RmReservation, rsrvType, ObjectType } from "../../../../ReservationI";
import { S25EventShareDataService } from "../../../s25.event.shared.data.service";
import { Subscription } from "rxjs";
import { Event } from "../../../../../../pojo/Event";
import { S25EditableStartEndDateTimeComponent } from "../../../../../s25-editable/s25-editable-start-end-datetime/s25.editable.start.end.date.time.component";
import { UserprefService } from "../../../../../../services/userpref.service";
import { S25Datefilter } from "../../../../../s25-dateformat/s25.datefilter.service";
import { WSReservations } from "../../../../EventMicroI";
import { ResourceService } from "../../../../../../services/resource.service";
import { Item } from "../../../../../../pojo/Item";
import { AvailWSResponse, ResourceSpaceAvailService } from "../../../../../../services/resource.space.avail.service";
import { NotificationService } from "../../../../../../services/notification.service";
import { FlsService } from "../../../../../../services/fls.service";
import { TaskCompetingUtil } from "../../../../../s25-task/task.competing.util";
import { AccessLevels, Fls } from "../../../../../../pojo/Fls";
import { TelemetryService } from "../../../../../../services/telemetry.service";
import WSSpaceAvail = AvailWSResponse.WSSpaceAvail;
import WSResourceAvail = AvailWSResponse.WSResourceAvail;
import DateElement = AvailWSResponse.DateElement;
import { AvailCheck } from "../../../../../../pojo/AvailabilityCheck";
import { S25ConflictsModule } from "../../../../../s25-conflicts/s25.conflicts.module";
import { S25PricingUtil } from "../../../../../s25-pricing/s25.pricing.util";
import { RecordType, S25Profile } from "../../../../ProfileI";
import { S25ProfileUtil } from "../../../../utils/s25.profile.util";
import { ProfileI } from "../../../../../../pojo/ProfileI";
import { ProfileUtil, PatternEndChoices } from "../../../../../s25-datepattern/profile.util";
import { ReservationService } from "../../../../../../services/reservation.service";
import {
    S25ObjectSearchUtil,
    LayoutTimesDuration,
    Layout,
} from "../../../../../s25-object-search/s25.object.search.util";
import { SpaceService } from "../../../../../../services/space.service";
import { S25ModalComponent } from "../../../../../s25-modal/s25.modal.component";
import { LayoutTimesComponent } from "../../../../../s25-object-search/layout.times.component";
import { WaitlistEntry, WaitingEntry } from "../../../../../../pojo/Waitlist";
import { WaitlistStore } from "../../../../../../stores/waitlist.store";
import { WaitlistComponent } from "../../../../../../standalone/s25-waitlist/s25.waitlist.component";
import { EventService } from "../../../../../../services/event.service";
import { S25InfoMessageModule } from "../../../../../s25-info-message/s25.info.message.module";
import { SpaceConflictErrorUtil } from "../../../../utils/space.conflict.error.util";
import {
    ObjectSearchRefresh,
    S25ObjectSearchComponent,
} from "../../../../../s25-object-search/s25.object.search.component";
import { ObjectSearchAvail } from "../../../../../s25-object-search/object.search.avail";
import { OccurrenceLocationRowComponent } from "./occurrence.location.row.component";
import { OccurrenceResourceRowComponent } from "./occurrence.resource.row.component";
import { emptyOccurrenceDeleteWarning, normalizeLocationFromObjectSearch } from "./occurrence.details.shared";
import {
    confirmBoundEventLocationChangeForOccurrence,
    getProfileReservationsForBoundLocationPrompt,
} from "../../../../utils/bound.event.location.util";
import { OccurrenceCopySegmentTargetComponent } from "./occurrence.copy.segment.target.component";
import {
    COPY_NEW_SEGMENT_KEY,
    copySegmentPatternChangeWarning,
    copySegmentProfileOptions,
    isCopyTargetSourceSegment,
    isNewSegmentNameValid,
    resolvedCopyTargetProfileId,
} from "./occurrence.copy.segment.util";

export type OccurrenceDetailsMode = "edit" | "copy" | "add";

@Component({
    selector: "occurrence-additional-details",
    template: `<div #rowLoadingSpinner><s25-loading-inline [model]="{}"></s25-loading-inline></div>
        @if (init) {
            <div class="occ-details-wrapper" [class.read-only]="!editMode && !isModalSaveMode">
                @if (isCopyMode) {
                    <occurrence-copy-segment-target
                        [segmentProfiles]="copySegmentProfileOptions()"
                        [sourceProfileId]="copySourceProfileId"
                        [repeatPatternOnSource]="copyRepeatPatternOnSource()"
                        [saveValidationAttempted]="copySegmentSaveValidationAttempted()"
                        [(copyTargetProfileKey)]="copyTargetProfileKey"
                        [(newSegmentName)]="newSegmentName"
                        (targetKeyChange)="onCopyTargetSegmentChange()"
                        (newSegmentNameEdited)="onNewSegmentNameChange()"
                    />
                }
                @if (canEdit && (hasPerm || isModalSaveMode)) {
                    @if (isModalSaveMode && profileCode && isCopyTargetSourceSegment()) {
                        <div class="c-margin-bottom--half">
                            <span class="ngBold">Keep Repeating Pattern</span>
                            <s25-toggle-button
                                (valueChange)="onToggleChange($event)"
                                [value]="repeatPatternToggle"
                                [trueLabel]="'On'"
                                [falseLabel]="'Off'"
                            ></s25-toggle-button>
                            @if (!repeatPatternToggle) {
                                <section class="cn-alert cn-alert--info cn-alert--notRealConflict">
                                    <section class="cn-alert__icon cn-icon cn-alert__icon--blue" name="alert--info">
                                        Warning: Selecting “No” will remove the repeating pattern from the event
                                        segment.
                                    </section>
                                </section>
                            }
                        </div>
                        @if (repeatPatternToggle) {
                            <span class="ngBold">{{ repetitionText }} </span>
                            <span class="c-margin-bottom--single c-margin-top--single"
                                >Extend the occurrence range of the existing repeat pattern:</span
                            >
                        }
                    }
                }

                <section class="date-time">
                    @if (!canEdit && !hasPerm) {
                        <s25-ng-editable-date
                            [val]="occ.eventStart || Date.now()"
                            [readOnly]="true"
                        ></s25-ng-editable-date>
                    }
                    @if (canEdit && (hasPerm || isModalSaveMode)) {
                        @if (profileCode && isModalSaveMode && repeatPatternToggle && isCopyTargetSourceSegment()) {
                            <section class="repeatPatrernSection">
                                @if (patternEndChoices === "date") {
                                    <span>Repeats through</span>
                                    <s25-ng-editable-date
                                        class="c-displayInlineBlock"
                                        [(val)]="throughDate"
                                        (valChange)="profileModelChange('date')"
                                        [alwaysEditing]="true"
                                    ></s25-ng-editable-date>
                                }

                                @if (patternEndChoices === "iterations") {
                                    <span>Ends after</span>
                                    <input
                                        [min]="profileModel.endsAfter"
                                        [max]="999"
                                        size="3"
                                        type="number"
                                        [(ngModel)]="endsAfter"
                                        (change)="profileModelChange('iterations', $event)"
                                        class="c-input"
                                    />
                                    iterations
                                }

                                @if (newOccsAvail.length > 0) {
                                    <div class="c-margin-top--single">
                                        <span>New occurrence date{{ newOccsAvail.length > 1 ? "s" : "" }}:</span>
                                        @for (r of newOccsAvail; track r?.evStartDt + i; let i = $index) {
                                            <div class="c-margin-left--double">
                                                {{ r.evStartDt | dateFormat: dateFormat }}
                                            </div>
                                        }
                                    </div>
                                }
                            </section>
                        }
                        @if (showOccurrenceDateTimePicker()) {
                            <s25-ng-editable-start-end-datetime
                                [startDatetime]="occ.eventStart || Date.now()"
                                (startDatetimeChange)="onChangeDate($event, 'start')"
                                [endDatetime]="occ.eventEnd || Date.now()"
                                (endDatetimeChange)="onChangeDate($event, 'end')"
                                [alwaysEditing]="true"
                                [noTimeUpdated]="true"
                            >
                            </s25-ng-editable-start-end-datetime>
                        }
                    }

                    @if (initSlider) {
                        <s25-ng-slider
                            [model]="{
                                type: 'time',
                                ranges: sliderRange,
                                step: 0.25,
                            }"
                            (onChange)="onSliderChange($event)"
                        ></s25-ng-slider>
                    }
                </section>
                @if (isOverlap()) {
                    <section class="cn-alert cn-alert--info cn-alert--notRealConflict">
                        <section class="cn-alert__icon cn-icon cn-alert__icon--blue" name="alert--info">
                            Warning: You have overlapping occurrences. Consider adjusting occurrence dates or durations.
                        </section>
                    </section>
                }
                @if (showPrivateObjsMsg()) {
                    <section class="cn-alert cn-alert--info cn-alert--notRealConflict">
                        <section class="cn-alert__icon cn-icon cn-alert__icon--blue" name="alert--info">
                            <s25-ng-icon [type]="'info'" [ariaLabel]="false" />
                            Cannot request location (Private) because you do not have view access.
                        </section>
                    </section>
                }

                @if (showRepeatPatternWarmingMsg) {
                    <section class="cn-alert cn-alert--info cn-alert--notRealConflict">
                        <section class="cn-alert__icon cn-icon cn-alert__icon--blue" name="alert--info">
                            <div>Warning:</div>
                            <div>{{ repetitionText }}</div>
                            <span
                                >With this change to date/time, the segment will no longer have a repeating pattern.
                            </span>
                        </section>
                    </section>
                }
                @if (isDatesChanged && !isModalSaveMode && assignAllowed()) {
                    <section class="date-time-buttons">
                        <button
                            class="aw-button aw-button--outline c-margin-right--single"
                            (click)="onchangeDateCancel()"
                        >
                            Cancel
                        </button>
                        <button class="aw-button aw-button--primary c-margin-right--single" (click)="save()">
                            Save
                        </button>
                    </section>
                }
                <section class="locations-resources">
                    @if (isModalSaveMode && assignAllowed()) {
                        <div class="object-search-buttons c-margin-bottom--single">
                            <div class="object-search-buttons__column">
                                <button
                                    class="aw-button aw-button--outline"
                                    (click)="onObjectSearch(Item.Ids.Location)"
                                    [disabled]="locSearchDisabled"
                                >
                                    Add Locations
                                </button>
                                @if (isCopyMode) {
                                    <button
                                        type="button"
                                        class="aw-button aw-button--danger--outline"
                                        (click)="removeAllCopyLocations()"
                                        [disabled]="!hasCopyLocations()"
                                    >
                                        Remove All Locations
                                    </button>
                                }
                            </div>
                            <div class="object-search-buttons__column">
                                <button
                                    class="aw-button aw-button--outline"
                                    (click)="onObjectSearch(Item.Ids.Resource)"
                                    [disabled]="resSearchDisabled"
                                >
                                    Add Resources
                                </button>
                                @if (isCopyMode) {
                                    <button
                                        type="button"
                                        class="aw-button aw-button--danger--outline"
                                        (click)="removeAllCopyResources()"
                                        [disabled]="!hasCopyResources()"
                                    >
                                        Remove All Resources
                                    </button>
                                }
                            </div>
                        </div>
                    }
                    <div>
                        @if (occ.locations?.length > 0) {
                            @for (arr of objectRsrvArr; track arr) {
                                <div>
                                    @for (l of occ.locations[0][arr]; track l?.itemId; let idx = $index) {
                                        <div>
                                            @if (occ.locations[0][arr]["length"] > 0) {
                                                <occurrence-location-row
                                                    [location]="l"
                                                    [rsrvType]="arr"
                                                    [index]="idx"
                                                    [canEdit]="canEdit"
                                                    [editMode]="editMode"
                                                    [isModalSaveMode]="isModalSaveMode"
                                                    [showConflict]="hasConflict && isConflict(l.itemId, 'location')"
                                                    [deleteWarning]="deleteWarning()"
                                                    [fls]="fls"
                                                    [waitlistEvents]="getWaitlistEntriesForLocation(l.itemId)"
                                                    [waitlistGroups]="getWaitlistGroupsForLocation(l.itemId)"
                                                    [locationWaitlistEnabled]="isLocationWaitlistEnabled(l.itemId)"
                                                    [hasWaitlistFls]="hasWaitlistFlsFor(l.itemId)"
                                                    (sharedChange)="onSharedChange($event, arr, idx)"
                                                    (confirmDelete)="
                                                        promptRemoveLocation(l.itemName, 'space', idx, arr)
                                                    "
                                                    (openSpaceConflict)="openSpaceConflictModal()"
                                                    (deleteConfirm)="
                                                        isModalSaveMode
                                                            ? onCopyOccObjectDelete('location', l.itemId, $event)
                                                            : onObjectDelete('location', l.itemId, arr, l, $event)
                                                    "
                                                    (layoutChange)="onLayoutChange($event, idx, arr)"
                                                    (attendanceChange)="
                                                        onAttendanceChange($event, l.attendance, idx, l, arr)
                                                    "
                                                    (textareaChange)="
                                                        onTextareaChange($event, Item.Ids.Location, l, arr, idx)
                                                    "
                                                    (openWaitlistDetail)="
                                                        openWaitlistDetail(
                                                            $event.waitlistId,
                                                            $event.groupKey,
                                                            l.itemName,
                                                            l.itemId
                                                        )
                                                    "
                                                />
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        }
                        @if (locationWaiting().length > 0) {
                            <div>
                                @for (r of locationWaiting(); track r.groupKey; let idx = $index) {
                                    <div class="location request">
                                        <div>
                                            <s25-item
                                                [itemId]="r.spaceId"
                                                [itemTypeId]="Item.Ids.Location"
                                                [itemName]="$safeNavigationMigration(r?.room?.roomShort)"
                                                [includeTypeIcon]="true"
                                                [typeIconClass]="'icon-space-pending'"
                                            >
                                            </s25-item>

                                            @if (canEdit || isModalSaveMode) {
                                                <div>
                                                    <button
                                                        class="aw-button aw-button--danger--transparent"
                                                        (click)="
                                                            promptRemoveLocation(
                                                                $safeNavigationMigration(r?.room?.roomShort),
                                                                'space',
                                                                idx,
                                                                'waitlist'
                                                            )
                                                        "
                                                        [disabled]="
                                                            deleteWarning().index === idx &&
                                                            deleteWarning().objType === 'space' &&
                                                            deleteWarning().rsrvType === 'waitlist'
                                                        "
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            }

                                            @if (isLocationWaitlistEnabled(r.spaceId)) {
                                                <button
                                                    class="aw-button aw-button--outline"
                                                    [disabled]="!hasWaitlistFlsFor(r.spaceId)"
                                                    (click)="
                                                        openWaitlistDetail(
                                                            r.waitlistId,
                                                            r.groupKey,
                                                            $safeNavigationMigration(r?.spaceName),
                                                            r.spaceId
                                                        )
                                                    "
                                                >
                                                    Waitlist Details
                                                    <s25-ng-icon [type]="'queue'" [ariaLabel]="false" />
                                                </button>
                                            }
                                        </div>
                                        @if (
                                            deleteWarning().index === idx &&
                                            deleteWarning().objType === "space" &&
                                            deleteWarning().rsrvType === "waitlist"
                                        ) {
                                            <s25-ng-delete-inline
                                                [confirmMsg]="deleteWarning().msg"
                                                [listItems]="deleteWarning().listItems"
                                                (onConfirm)="onWaitlistDelete(r, $event)"
                                            ></s25-ng-delete-inline>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <!-- end location waitlist-->
                    </div>
                    <!-- end location section -->
                    @if (occ.resources?.length > 0) {
                        <div>
                            @for (arr of objectRsrvArr; track arr) {
                                <div>
                                    @for (r of occ.resources[0][arr]; track r?.itemId; let i = $index) {
                                        <div>
                                            @if (occ.resources[0][arr]["length"] > 0) {
                                                <occurrence-resource-row
                                                    [resource]="r"
                                                    [rsrvType]="arr"
                                                    [index]="i"
                                                    [canEdit]="canEdit"
                                                    [isModalSaveMode]="isModalSaveMode"
                                                    [showConflict]="hasConflict && isConflict(r.itemId, 'resource')"
                                                    [deleteWarning]="deleteWarning()"
                                                    (confirmDelete)="
                                                        setConfirmDeleteMsg(r.itemName, 'resource', i, arr)
                                                    "
                                                    (openSpaceConflict)="openSpaceConflictModal()"
                                                    (deleteConfirm)="
                                                        isModalSaveMode
                                                            ? onCopyOccObjectDelete('resource', r.itemId, $event)
                                                            : onObjectDelete('resource', r.itemId, arr, r, $event)
                                                    "
                                                    (quantityChange)="onQuantityChange($event, r.quantity, i, r, arr)"
                                                    (textareaChange)="
                                                        onTextareaChange($event, Item.Ids.Resource, r, arr, i)
                                                    "
                                                />
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </section>

                <section class="c-margin-top--single c-margin-bottom--single">
                    <label>
                        Occurrence Comments:
                        <s25-ng-editable-textarea
                            [val]="$safeNavigationMigration(occurrence()?.comments)"
                            [readOnly]="!canEdit"
                            placeholder="Add comments"
                            [hasCommit]="!isModalSaveMode"
                            [hasCancelButton]="!isModalSaveMode"
                            [hasCommitButton]="!isModalSaveMode"
                            [renderHtml]="true"
                            commitButtonText="Save"
                            cancelButtonText="Cancel"
                            (valChange)="onOccCommentsChange($event)"
                        />
                    </label>
                </section>
                @if (isModalSaveMode && assignAllowed()) {
                    <section class="buttons" #actionLoadingSpinner>
                        <button
                            class="aw-button aw-button--primary c-margin-right--single"
                            [disabled]="copyOccSaveButtonDisabled || saving()"
                            (click)="save()"
                        >
                            Save
                        </button>
                        <button
                            class="aw-button aw-button--outline c-margin-right--single"
                            [disabled]="saving()"
                            (click)="cancel()"
                        >
                            Cancel
                        </button>
                        <s25-loading-inline [model]="{}" class="buttons-loading"></s25-loading-inline>
                    </section>
                }
            </div>

            <s25-ng-modal
                #objectSearchModal
                class="object-search-modal"
                [title]="objectSearchItemTypeId === Item.Ids.Location ? 'Locations Search' : 'Resources Search'"
                [size]="'xl'"
            >
                <ng-template #s25ModalBody>
                    <s25-ng-object-search
                        #objectSearchComponent
                        [itemTypeId]="objectSearchItemTypeId"
                        [occ]="occ"
                        [profileId]="profileId"
                        [eventId]="eventId"
                        [selectedItems]="[occ.itemId]"
                        [event]="objectSearchEvent ?? occurrencesService.S25Event()!"
                        [expectedCount]="expectedCount"
                        (refreshF)="onObjectSearchRefresh($event)"
                        (cancelled)="objectSearchModal?.close()"
                    />
                </ng-template>
            </s25-ng-modal>

            <s25-ng-modal #layoutConflictModal [title]="'Layout Setup/Takedown times'" [size]="'md'">
                <ng-template #s25ModalBody>
                    <layout-times
                        #layoutTimesComponent
                        [setup]="layoutDetail.setup"
                        [takedown]="layoutDetail.takedown"
                        [itemName]="layoutDetail.itemName"
                        [conflicts]="layoutDetail.conflicts"
                        (valuesChanged)="layoutTimesChange($event)"
                    />
                </ng-template>
            </s25-ng-modal>

            <s25-ng-modal #spaceConflictModal [title]="'Conflicts'" [size]="'md'">
                <ng-template #s25ModalBody>
                    <p class="c-margin-bottom--half">
                        {{ spaceConflictMessage() }}
                    </p>
                    <s25-ng-conflicts [model]="displayConflicts()"></s25-ng-conflicts>
                </ng-template>
            </s25-ng-modal>

            <s25-ng-modal #waitlistDetailModal [title]="waitlistDetailTitle()" [size]="'xl'">
                <ng-template #s25ModalBody>
                    @if (showWaitlistDetailModal()) {
                        <s25-ng-waitlist
                            [waitlistId]="selectedWaitlistId() ?? undefined"
                            [groupKey]="selectedWaitlistGroupKey() ?? undefined"
                            [itemId]="selectedWaitlistSpaceId() ?? undefined"
                            [startDt]="selectedWaitlistStartDt()"
                        />
                    }
                </ng-template>
            </s25-ng-modal>
        }`,
    styles: `
        :host > div:not(.occ-details-wrapper) {
            width: fit-content;
            margin: auto;
        }

        .occ-details-wrapper {
            container: details-wrapper / inline-size;
            display: flex;
            flex-direction: column;
            padding: 1rem;

            .date-time {
                display: flex;
                gap: 1em;
                padding-bottom: 1em;
                min-height: 17em;

                s25-ng-editable-start-end-datetime {
                    ::ng-deep .c-start-end-datetime-picker--wrapper {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        gap: 5px;
                        padding: 1rem;
                        height: 100%;
                        border-radius: 5px;
                        box-shadow:
                            rgba(0, 0, 0, 0.05) 0 6px 24px 0,
                            rgba(0, 0, 0, 0.08) 0 0 0 1px;
                    }

                    ::ng-deep .c-start-end-datetime-picker--wrapper input {
                        width: 11rem;
                    }

                    ::ng-deep .c-start-end-datetime-picker--wrapper s25-ng-editable-date {
                        min-width: 8em;
                    }

                    ::ng-deep .c-start-end-datetime-picker--wrapper s25-ng-editable-date span {
                        font-weight: bolder;
                    }

                    ::ng-deep .c-start-end-datetime-picker--wrapper > div {
                        width: 11rem;
                    }

                    ::ng-deep .c-start-end-datetime-picker--wrapper > div .ngDropdownPaginated {
                        width: 11rem;
                    }

                    ::ng-deep .c-start-end-datetime-picker--wrapper > div label.c-label--checkbox.inline {
                        width: 100%;
                    }

                    @container details-wrapper (width < 700px) {
                        ::ng-deep .c-start-end-datetime-picker--wrapper > div,
                        ::ng-deep p {
                            margin: auto !important;
                        }
                    }
                }

                .repeatPatrernSection {
                    display: flex;
                    flex-direction: row;
                    justify-content: left;
                }

                s25-ng-slider {
                    flex-basis: 80%;

                    ::ng-deep .slider-wrapper {
                        box-shadow:
                            rgba(0, 0, 0, 0.05) 0 6px 24px 0,
                            rgba(0, 0, 0, 0.08) 0 0 0 1px;
                        border-radius: 5px;
                        height: 100%;
                    }
                }

                @container details-wrapper (width < 700px) {
                    height: 32em;
                    flex-direction: column;
                }
            }

            .date-time-buttons {
                padding-bottom: 1em;
            }

            .locations-resources {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 1rem;

                .object-search-buttons {
                    grid-column: 1 / -1;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 1rem;
                }

                .object-search-buttons__column {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                    align-items: flex-start;
                }

                & > div:not(.object-search-buttons) {
                    ::ng-deep :is(.location, .resource) {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        padding: 10px;
                        margin-block: 10px;
                        border-radius: 5px;
                        box-shadow:
                            rgba(0, 0, 0, 0.05) 0 6px 24px 0,
                            rgba(0, 0, 0, 0.08) 0 0 0 1px;
                        min-width: 20em;
                    }

                    ::ng-deep :is(.location, .resource):not(:last-child) {
                        border-bottom: 1px solid darkgrey;
                    }

                    ::ng-deep :is(.location, .resource) > div:first-child {
                        display: flex;
                        justify-content: space-between;
                        gap: 5px;
                        width: 100%;
                    }

                    ::ng-deep :is(.location, .resource) > div:first-child .s25-item-holder {
                        display: flex;
                        position: relative;
                        top: 4px;
                        cursor: pointer;
                    }

                    ::ng-deep :is(.location, .resource) > div:first-child .s25-item-name {
                        font-weight: 600;
                    }

                    ::ng-deep :is(.location, .resource) > div:last-child {
                        width: 100%;
                        text-align: start;
                    }

                    ::ng-deep :is(.location, .resource) label {
                        width: 100%;
                    }

                    ::ng-deep :is(.location, .resource) label select {
                        max-width: 19em;
                    }

                    ::ng-deep :is(.location, .resource) s25-ng-delete-inline {
                        margin-top: 1em;
                    }

                    ::ng-deep :is(.location, .resource) s25-ng-delete-inline .button-group {
                        width: fit-content;
                        margin: auto;
                    }

                    ::ng-deep
                        :is(.location, .resource)
                        :is(s25-ng-editable-number, s25-ng-editable-textarea)
                        div:is(:has(.c-input), :has(textarea)) {
                        display: flex;
                        flex-wrap: wrap;
                    }

                    ::ng-deep :is(.location, .resource) s25-ng-editable-number input {
                        width: 6em;
                    }
                }

                @container details-wrapper (width < 700px) {
                    grid-template-columns: 1fr;
                }
            }

            &.read-only {
                ::ng-deep :is(.location, .resource) {
                    flex-direction: row !important;
                    align-items: center !important;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                ::ng-deep :is(.location, .resource) label {
                    width: fit-content !important;
                }

                ::ng-deep :is(.location, .resource) > div {
                    width: unset !important;
                }

                ::ng-deep :is(.location, .resource) > div:last-child {
                    flex-basis: 100%;
                }
            }

            .buttons {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 0.5rem;
            }

            .buttons-loading {
                display: inline-flex;
                align-items: center;
            }
        }

        @media screen and (width <= 1200px) {
            .date-time {
                s25-ng-slider {
                    width: 100%;
                }
            }
        }

        @media screen and (width <= 770px) {
            .locations-resources {
                grid-template-columns: 1fr !important;
            }
        }

        .object-search-modal {
            ::ng-deep .s25-modal--body {
                overflow: hidden;
                display: flex;
                flex-direction: column;
            }
        }

        occurrence-location-row {
            ::ng-deep .waitlist-row {
                display: flex;
                align-items: center;
            }

            ::ng-deep .occurrence-shared-control {
                display: flex;
                align-items: center;
                gap: 0.25rem;
                flex-wrap: wrap;
            }
        }

        ::ng-deep s25-toggle-button .toggle__label--2 {
            margin-left: 1.75em !important;
        }

        :host-context(.nm-party--on) .occ-details-wrapper {
            .date-time s25-ng-editable-start-end-datetime ::ng-deep .c-start-end-datetime-picker--wrapper,
            .date-time s25-ng-slider ::ng-deep .slider-wrapper,
            .locations-resources > div:not(.object-search-buttons) ::ng-deep :is(.location, .resource) {
                box-shadow:
                    rgba(255, 255, 255, 0.05) 0 6px 24px 0,
                    rgba(255, 255, 255, 0.1) 0 0 0 1px;
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        S25ObjectSearchModule,
        S25ModalModule,
        S25LoadingInlineModule,
        S25EditableModule,
        S25DeleteModule,
        S25ItemComponent,
        S25CheckboxModule,
        S25IconComponent,
        S25SliderModule,
        S25PipesModule,
        FormsModule,
        S25ToggleButtonModule,
        WaitlistComponent,
        S25InfoMessageModule,
        S25ConflictsModule,
        OccurrenceLocationRowComponent,
        OccurrenceResourceRowComponent,
        OccurrenceCopySegmentTargetComponent,
    ],
})
export class OccurrenceAdditionalDetailsComponent implements OnDestroy, OnInit, OnChanges {
    @Input({ required: true }) occ!: S25Reservation;
    @Input() mode: OccurrenceDetailsMode = "edit";
    @Input() canEdit?: boolean;
    @Input() eventId?: number;
    @Input() profileId?: number;
    @Input() selectedItems?: number[];
    @Input() eventState?: Event.State.Ids;
    @Input() copyInitOcc?: S25Reservation;
    @Input() editMode?: boolean;

    @Output() onSave = new EventEmitter<{ id: number }>();
    @Output() onCancel = new EventEmitter<void>();
    @Output() refreshF = new EventEmitter<void>();
    @ViewChild(S25EditableStartEndDateTimeComponent) editDateTimeComponent?: S25EditableStartEndDateTimeComponent;

    @ViewChild("rowLoadingSpinner") rowLoadingSpinner?: ElementRef;
    @ViewChild("actionLoadingSpinner") actionLoadingSpinner?: ElementRef;

    @ViewChild("layoutConflictModal") layoutConflictModal?: S25ModalComponent;
    @ViewChild("layoutTimesComponent") layoutTimesComponent?: LayoutTimesComponent;
    @ViewChild("waitlistDetailModal") waitlistDetailModal?: S25ModalComponent;
    @ViewChild("spaceConflictModal") spaceConflictModal?: S25ModalComponent;
    @ViewChild("objectSearchModal") objectSearchModal?: S25ModalComponent;
    @ViewChild("objectSearchComponent") objectSearchComponent?: S25ObjectSearchComponent;

    get isModalSaveMode(): boolean {
        return this.mode === "copy" || this.mode === "add";
    }

    get isCopyMode(): boolean {
        return this.mode === "copy";
    }
    readonly displayConflicts = signal<AvailCheck.ConflictDefaults[]>([]);
    readonly saving = signal(false);
    readonly spaceConflictMessage = signal(SpaceConflictErrorUtil.SAVE_BLOCKED_MESSAGE);
    readonly selectedWaitlistId = signal<number | undefined>(undefined);
    readonly selectedWaitlistGroupKey = signal<string | undefined>(undefined);
    readonly selectedWaitlistSpaceId = signal<number | undefined>(undefined);
    readonly selectedWaitlistStartDt = signal<Date | undefined>(undefined);
    readonly selectedWaitlistSpaceName = signal<string>("");
    readonly showWaitlistDetailModal = computed(
        () => this.selectedWaitlistId() != null || !!this.selectedWaitlistGroupKey(),
    );
    readonly waitlistDetailTitle = computed(() => {
        const name = this.selectedWaitlistSpaceName();
        return name ? `${name} : Waitlist Details` : "Waitlist Details";
    });

    private waitlistStore = inject(WaitlistStore);

    initOcc: S25Reservation;
    init: boolean = false;
    objectRsrvArr = ["reserved", "draft", "requested"];
    hasConflict: boolean = false;
    sliderRange: Range[] = [];
    initSliderRange: Range[] = [];
    findResourcesConflict: any = [];
    findLocationConflict: any = [];
    event: S25Event;
    private selectedItemsSubscription?: Subscription;
    isDatesChanged: boolean = false;
    dateFormat: string = "";
    timeFormat: string = "";
    deleteWarning = signal(emptyOccurrenceDeleteWarning());
    hasPerm: boolean = false;
    fls?: Fls;
    waitlistFlsMap = new Map<number, boolean>();
    locationWaitlistMap = new Map<number, string>();
    isEventOwner = false;
    occurrence = computed<S25Reservation | undefined>(() =>
        this.occurrencesService.getOccurrences().find((rsrv) => rsrv.itemId === this.occ?.itemId),
    );
    initSlider: boolean = true;
    isOverlap = signal<boolean>(false);
    assignAllowed = signal<boolean>(true);
    private lock: Promise<any> = Promise.resolve();
    profileCode?: string = undefined;
    profileModel = {} as ProfileI;
    patternEndChoices?: PatternEndChoices; //none, date, iterations
    repetitionText?: string;
    throughDate?: Date;
    endsAfter?: number;
    newOccsAvail: any[] = [];
    newProfileCode?: string;
    copyOccSaveButtonDisabled: boolean = false;
    copySourceProfileId?: number;
    copyTargetProfileKey = "";
    newSegmentName = "";
    readonly copySegmentSaveValidationAttempted = signal(false);
    showRepeatPatternWarmingMsg: boolean = false;
    repeatPatternToggle: boolean = false;
    showPrivateObjsMsg = signal<boolean>(false);
    objectSearchItemTypeId: Item.Ids = Item.Ids.Location;
    locSearchDisabled = false;
    resSearchDisabled = false;
    expectedCount?: number;
    objectSearchEvent?: S25Event;

    protected readonly Item = Item;

    layoutDetail = {} as LayoutTimesDuration;

    locationWaiting = signal<WaitlistEntry[]>([]);

    private pendingLayoutContext?: {
        index: number;
        type: rsrvType;
        originalLayoutId?: number;
        originalLayoutName?: string;
        findLayout: Layout;
    };

    constructor(
        private cd: ChangeDetectorRef,
        private zone: NgZone,
        protected occurrencesService: S25EventOccurrencesService,
        private elementRef: ElementRef,
        private shareDataService: S25EventShareDataService,
    ) {}

    private selectedReservationIds(): number[] {
        const ids: number[] = Object.values(S25Util.clone(this.selectedItems ?? []));
        if (!ids.includes(this.occ.itemId)) ids.push(this.occ.itemId);
        return ids;
    }

    private buildInlineEditPayload(reservations: Partial<WSReservations>[]): EventDataMicroI {
        return {
            items: [
                {
                    kind: "event",
                    id: this.eventId,
                    profiles: [{ profileId: this.profileId, reservations }],
                },
            ],
        };
    }

    private postInlineEditNotifications(ok: {
        content?: { errors?: { message: string }[]; messages?: { message: string }[] };
    }): boolean {
        const notifications = ok?.content?.errors || ok?.content?.messages;
        if (!notifications?.length) return false;
        for (const notice of notifications) {
            NotificationService.post(notice.message);
        }
        return true;
    }

    private async runInlineReservationSave(
        payload: EventDataMicroI,
        options: { telemetrySub?: string; refresh?: "always" | "when-clean" | "never" } = {},
    ): Promise<[ok: unknown, error: unknown]> {
        const refresh = options.refresh ?? "when-clean";
        this.setLoading(true);
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", options.telemetrySub ?? "EditMode");
        const [ok, error] = await S25Util.Maybe(
            this.occurrencesService.runInlineEditScenarios(this.eventId!, () =>
                EventMicroService.putEventReservation(this.eventId!, payload),
            ),
        );
        if (ok) {
            const hadNotifications = this.postInlineEditNotifications(
                ok as { content?: { errors?: { message: string }[]; messages?: { message: string }[] } },
            );
            if (refresh === "always" || (refresh === "when-clean" && !hadNotifications)) {
                this.occurrencesService.getEvent(this.eventId!, false, ok);
                this.cd.detectChanges();
            }
        }
        this.setLoading(false);
        return [ok, error];
    }

    private mergeOccReserved<T extends S25RmReservation | S25RsReservation>(
        existing: { reserved?: T[]; draft?: T[]; requested?: T[] }[] | undefined,
        items: T[],
        setContainer: (container: { reserved: T[]; draft: T[]; requested: T[] }) => void,
    ): void {
        if (!existing?.length) {
            setContainer({ reserved: items, draft: [], requested: [] });
            return;
        }
        existing[0].reserved ??= [];
        existing[0].reserved.push(...items);
    }

    sortByRsrvName(arr: S25Reservation[]) {
        if (!arr || arr.length === 0) return;
        arr.sort((a, b) => (a.itemName > b.itemName ? 1 : a.itemName < b.itemName ? -1 : 0));
    }

    async ngOnInit() {
        setTimeout(() => {
            this.rowLoadingSpinner && S25LoadingApi.init(this.rowLoadingSpinner.nativeElement);
        });
        const [dateFormat, timeFormat, fls] = await Promise.all([
            UserprefService.getS25Dateformat(),
            UserprefService.getS25Timeformat(),
            FlsService.getFls(),
        ]);
        this.fls = fls;
        this.dateFormat = dateFormat;
        this.timeFormat = timeFormat;
        this.occ?.locations?.forEach((item) => Object.values(item).forEach(this.sortByRsrvName));
        this.occ?.resources?.forEach((item) => Object.values(item).forEach(this.sortByRsrvName));
        if (!this.initOcc) this.initOcc = S25Util.deepCopy(this.occ);
        this.setSliderRange();
        this.selectedItemsSubscription = this.shareDataService.getSelectedItems().subscribe((items) => {
            this.selectedItems = items;
        });

        this.hasPerm = S25ReservationUtil.checkObjHasPerm(this.occurrencesService.getOccurrences());

        this.eventState === Event.State.Ids.Draft
            ? (this.objectRsrvArr = ["draft"])
            : (this.objectRsrvArr = ["reserved", "requested"]);

        this.profileCode = S25ProfileUtil.getProfileCode(this.occurrencesService?.getProfiles(), this.occ?.profileId);
        this.initCopySegmentTarget();
        if (this.profileCode) {
            this.throughDate = ProfileUtil.getProfileCodeThroughDate(this.profileCode);
            this.profileModel = ProfileUtil.getProfileModel(null, this.profileCode, this.throughDate, null);
            this.patternEndChoices = this.profileModel.repeatEnd;
            this.repetitionText = EventOccUtil.getRepetitionText(this.profileCode);
            this.endsAfter = this.profileModel.endsAfter;
            this.repeatPatternToggle = this.mode === "copy";
            if (this.mode === "copy") {
                this.copyOccSaveButtonDisabled = true;
            }
        }
        if (this.isModalSaveMode) {
            this.setSearchButtons();
            const event = this.occurrencesService.S25Event();
            if (event?.profile && this.profileId) {
                const profile = S25ProfileUtil.getProfileByProfileId(event.profile, this.profileId);
                if (profile?.expectedCount != null) {
                    this.expectedCount = profile.expectedCount;
                }
            }
        }
        if (this.isModalSaveMode) this.checkOverlapping(this.occ.eventStart);
        setTimeout(() => {
            this.rowLoadingSpinner && S25LoadingApi.destroy(this.rowLoadingSpinner.nativeElement);
        });

        this.setShowPrivateObjsMsg();

        this.getLocationWaiting();
        await this.loadWaitlistFls(fls);

        this.init = true;
        this.cd.detectChanges();
    }

    async onTextareaChange(
        newVal: string,
        itemTypeId: number,
        obj?: S25RmReservation | S25Reservation,
        type?: rsrvType,
        index?: number,
    ): Promise<void | false> {
        if (this.isModalSaveMode) return false;
        if (!this.occ || type == null || index == null) return;

        const isLocation = itemTypeId === Item.Ids.Location;

        const container = isLocation ? this.occ.locations?.[0] : this.occ.resources?.[0];

        const list = container?.[type];
        const item = list?.[index];

        if (!item) return;

        item.instructions = newVal;
        this.updateObject(item, type, isLocation ? Item.Ids.Location : Item.Ids.Resource);
    }

    // All space and resource reservations input with no label (draft,  request  & reserved)
    async onObjectDelete(
        type: ObjectType,
        id: number,
        nodeName: string,
        removeItem: S25RmReservation | S25RsReservation,
        confirmed: boolean,
    ) {
        this.deleteWarning.set(emptyOccurrenceDeleteWarning());
        if (!confirmed) return;

        // Create a lock that ensures only one operation happens at a time
        const currentLock = this.lock;
        this.lock = this.lock.then(async () => {
            const restult = await EventOccUtil.normalizeDeleteRsrvWSData(
                removeItem as S25RmReservation,
                null,
                nodeName,
                this.occ,
                type,
            );

            const reservations = this.selectedReservationIds().map((rsrvId) => ({
                rsrvId,
                remove: restult.remove,
            }));

            const payload = this.buildInlineEditPayload(reservations);

            this.setLoading(true);
            TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", "Remove" + type);
            const [ok, errors] = await S25Util.Maybe(
                this.occurrencesService.runInlineEditScenarios(this.eventId!, () =>
                    EventMicroService.putEventReservation(this.eventId!, payload),
                ),
            );
            this.setLoading(false);
            if (ok) {
                if (ok?.content?.errors) {
                    for (const error of ok?.content?.errors) {
                        NotificationService.post(error.message);
                    }
                } else {
                    if (type === "location") {
                        S25ReservationUtil.removeLocationsById(this.occ, [id]);
                    } else {
                        S25ReservationUtil.removeResourceById(this.occ, [id]);
                    }

                    this.occurrencesService.getEvent(this.eventId!, false, ok);
                    this.cd.detectChanges();
                    this.refreshF.emit();
                }
            }
            if (errors)
                return S25Util.showError(errors, "There was an error while attempting to delete this reservation.");
        });
        // Wait for the current operation to complete before unlocking
        await currentLock;
    }

    async onLayoutChange(e: Event, index: number, type: rsrvType): Promise<void> {
        const occ = this.occ;
        const container = occ?.locations?.[0];
        const item = container?.[type]?.[index];

        if (!occ || !container || !item) return;

        const select = e.target as HTMLSelectElement | null;
        if (!select) return;

        // Store original values BEFORE changing
        const originalLayoutId = item.layout?.itemId;
        const originalLayoutName = item.layout?.itemName;

        const newLayoutId = Number(select.value);

        if (!item.layout) return;

        const findLayout = item.locationLayout?.find((l: Layout) => l.layout_id === newLayoutId);

        item.layout.itemId = newLayoutId;
        item.layout.itemName = findLayout?.layout_name ?? "";
        if (findLayout?.layout_capacity != null) {
            item.layout.capacity = findLayout.layout_capacity;
        } else if (item.layout.roomCapacity != null) {
            item.layout.capacity = item.layout.roomCapacity;
        }

        if (findLayout?.layout_instruction) {
            item.instructions = findLayout.layout_instruction;
        }

        // No layout times → update immediately
        if (!findLayout?.layout_setup_tm && !findLayout?.layout_tdown_tm) {
            this.updateObject(item, type, Item.Ids.Location);
            return;
        }

        const event = this.occurrencesService.S25Event();
        if (!event || this.profileId == null) return;

        const profileTimes = S25ObjectSearchUtil.getProfileTimes(event, this.profileId);

        const setup = S25Util.ISODurationToMinutes(findLayout.layout_setup_tm) || 0;
        const takedown = S25Util.ISODurationToMinutes(findLayout.layout_tdown_tm) || 0;

        const setupDiff = setup - profileTimes.setup;
        const takedownDiff = takedown - profileTimes.takedown;

        if (setupDiff <= 0 && takedownDiff <= 0) {
            // ANG-7126 when layout setup/takedown times less than or equal to event additional setup/takedown times
            // leave the profile init_start_dt unchanged, so call updateObject(), no need call save() and adjust profile/rsrv datetimes
            this.updateObject(item, type, Item.Ids.Location);
            return;
        }

        const profile = event.profile?.find((p) => p.itemId === this.profileId);
        if (!profile) return;

        // ANG-7706: setup/takedown is profile-wide — check every reservation on the segment
        const reservations =
            profile.reservations?.filter((r): r is S25Reservation => "itemId" in r && r.itemId !== undefined) ?? [];

        const dates = S25ReservationUtil.getReservationsStartEndDates(reservations);
        const adjustedDates = S25ObjectSearchUtil.adjustDates(dates, setupDiff, takedownDiff);

        const rsrvObjects = (await S25ReservationUtil.getRsrvsObjects(reservations)) ?? {
            allLocations: [],
            allResources: [],
        };
        const allSpaceIds = [
            ...new Set(
                [item.itemId, ...S25Util.toItemIds(rsrvObjects.allLocations as S25RmReservation[])].filter(
                    (spaceId): spaceId is number => !!spaceId && Number.isFinite(spaceId),
                ),
            ),
        ];

        const resources = (rsrvObjects.allResources as S25RsReservation[]).filter((resource) => !!resource.itemId);
        const eventId = this.eventId;
        const profileId = this.profileId;
        const [spaceAvailability, resourceAvailability] = await Promise.all([
            SpaceService.getSpaceDatesAvailability(allSpaceIds, adjustedDates, eventId, profileId),
            resources.length && eventId != null && profileId != null
                ? ResourceService.getResourceDatesAvailability(resources, adjustedDates, eventId, profileId)
                : Promise.resolve(undefined),
        ]);

        const hasNonOverridableSpaceConflict = spaceAvailability?.spaces?.space?.some(
            (space: WSSpaceAvail) =>
                space.has_conflicts === "T" &&
                !space.dates?.every(
                    (date: DateElement) =>
                        !date.conflict?.length ||
                        date.conflict.every((conflict) =>
                            S25ObjectSearchUtil.canOverrideConflict(conflict.conflict_type, this.fls!),
                        ),
                ),
        );
        const hasResourceConflict = resourceAvailability?.resources?.resource?.some(
            (resource: WSResourceAvail) => resource.has_conflicts === "T",
        );

        if (hasNonOverridableSpaceConflict || hasResourceConflict) {
            this.layoutDetail = {
                itemName: item.itemName,
                setup: S25Util.minutesToISODuration(setup),
                takedown: S25Util.minutesToISODuration(takedown),
                conflicts: S25ObjectSearchUtil.buildLayoutExtensionConflicts(
                    spaceAvailability,
                    resourceAvailability,
                    this.fls!,
                ),
            };

            this.pendingLayoutContext = {
                index,
                type,
                originalLayoutId,
                originalLayoutName,
                findLayout,
            };

            this.layoutConflictModal?.open();
            return;
        }

        this.save(setupDiff > 0 ? setup : profileTimes.setup, takedownDiff > 0 ? takedown : profileTimes.takedown);
    }

    async onChangeDate(newDate: Date, text: "start" | "end") {
        this.isDatesChanged = true;
        this.newDateSet(newDate, text);
        if (text === "start") this.checkOverlapping(newDate);
        if (
            (this.profileCode && this.repeatPatternToggle && !this.isModalSaveMode) ||
            (this.profileCode && !this.repeatPatternToggle && this.isModalSaveMode)
        )
            this.showRepeatPatternWarmingMsg = true;
        this.getLocationWaiting();
        this.cd.detectChanges();
    }

    async onchangeDateCancel() {
        this.occ = S25Util.clone(this.initOcc);
        await this.editDateTimeComponent?.refreshDatetimes({
            startDatetime: this.occ.eventStart,
            endDatetime: this.occ.eventEnd,
        });
        this.isDatesChanged = false;
        this.showRepeatPatternWarmingMsg = false;
        this.getLocationWaiting();
        this.cd.detectChanges();
    }

    @Debounce(300) // Avoid double calls
    onSliderChange(e: any) {
        const date: any = [{ startDt: e.ranges[1].start, endDt: e.ranges[1].end }];
        this.checkObjectsAvailability(date, this.fls);

        // this.initSliderRange.forEach((range: any, index: number ) => {
        //      // Update the start property of the range in initMode
        //      range.start = (new Date(range.start)).setHours( e.ranges[index].start);
        //      range.start = (new Date(range.start)).setMinutes( (e.ranges[index].start % 1) * 60);
        //      range.start = new Date(range.start);

        //      range.end = (new Date(range.end)).setHours( e.ranges[index].end);
        //      range.end = (new Date(range.end)).setMinutes( (e.ranges[index].end % 1) * 60);
        //      range.end = new Date(range.end);
        //  });
        //   console.log('tempSliderRange', this.initSliderRange);
    }

    async onAttendanceChange(newVal: number, initVal: number, index: number, l: S25RmReservation, type: rsrvType) {
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", "ChangeAttendance");
        this.occ.locations[0][type][index].attendance = this.initOcc.locations[0][type][index].attendance;
        this.occ.locations[0][type][index].attendance = newVal;
        const updateItem = this.occ.locations[0][type][index];
        this.updateObject(updateItem, type, Item.Ids.Location);
    }

    async onQuantityChange(newVal: number, initVal: number, index: number, r: S25RsReservation, type: rsrvType) {
        if (this.isModalSaveMode) {
            const resource = this.occ.resources?.[0]?.[type]?.[index];
            if (resource) {
                resource.quantity = newVal;
            }
            return;
        }
        const rvrs = this.occurrencesService
            .getOccurrences()
            .filter((item) => this.selectedReservationIds().includes(item.itemId));
        const datesArr = S25ReservationUtil.getReservationsStartEndDates(rvrs);
        const checkItem = [{ itemId: r.itemId, quantity: newVal }];
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", "ChangeQuantity");
        const [result, error] = await S25Util.Maybe(
            ResourceService.getResourceDatesAvailability(checkItem, datesArr, this.eventId, this.profileId),
        );

        if (result) {
            const resultRes = result.resources.resource[0];
            const availQyt =
                resultRes.dates[0]?.stock_level || resultRes.dates[0]?.stock_level === 0
                    ? resultRes.dates[0].stock_level
                    : 3665;
            const noRequest = resultRes.dates.filter((item: DateElement) => item.perm_name === "No Request");
            const hasCoflict = resultRes.has_conflicts !== "F";
            this.occ.resources[0][type][index].quantity = this.initOcc.resources[0][type][index].quantity;
            if (availQyt >= newVal && noRequest.length === 0 && !hasCoflict) {
                this.occ.resources[0][type][index].quantity = newVal;
                const updateItem = this.occ.resources[0][type][index];
                this.updateObject(updateItem, type, Item.Ids.Resource);
            } else {
                this.occ.resources[0][type][index].quantity = initVal;
                this.cd.detectChanges();
                if (hasCoflict) {
                    const conflicts = ResourceSpaceAvailService.toDisplayConflicts(result, "resource", this.fls);
                    this.showSpaceConflictModal(conflicts);
                } else if (noRequest.length > 0) {
                    alert(
                        "You cannot request or reserve this resource on the selected date. Please adjust or exclude the occurrence date(s)",
                    );
                } else if (newVal > availQyt) {
                    alert("Please enter a integer size less than or equal to " + availQyt);
                }
                return false;
            }
        }

        if (error) return S25Util.showError(error, "There was an error while attempting to update this reservation.");
        return false;
    }

    async newDateSet(newDate: Date, text: "start" | "end") {
        const getStartDiffMinutes: number = S25Util.date.diffMinutes(this.initOcc.eventStart, this.occ.eventStart);
        let getEndDiffMinutes: number = S25Util.date.diffMinutes(this.initOcc.eventEnd, this.occ.eventEnd);

        if (text === "start") {
            this.occ.eventStart = newDate;
            //start date changed, check   assignBuffer
            const hasAssignBuffer = S25ReservationUtil.checkObjHasAssignBuffer(this.occ.locations, true);
            if (hasAssignBuffer && this.fls.SPACE_ASSIGN_OVER !== "F") {
                await S25ReservationUtil.checkAssignBuffer(newDate, this.occ.locations);
                this.assignAllowed.set(await !S25ReservationUtil.checkObjHasAssignBuffer(this.occ.locations, false));
            }
        } else {
            getEndDiffMinutes = S25Util.date.diffMinutes(this.initOcc.eventEnd, newDate);
            this.occ.eventEnd = newDate;
        }

        if (this.occ?.preEventStart)
            this.occ.preEventStart = S25Util.date.addMinutes(this.initOcc.preEventStart, getStartDiffMinutes);
        if (this.occ?.setupStart)
            this.occ.setupStart = S25Util.date.addMinutes(this.initOcc.setupStart, getStartDiffMinutes);
        if (this.occ?.postEventEnd)
            this.occ.postEventEnd = S25Util.date.addMinutes(this.initOcc.postEventEnd, getEndDiffMinutes);
        if (this.occ?.takeDownEnd)
            this.occ.takeDownEnd = S25Util.date.addMinutes(this.initOcc.takeDownEnd, getEndDiffMinutes);
    }

    @Debounce(300) // Avoid double calls
    async checkObjectsAvailability(date: [], fls: Fls) {
        if (!this.eventId || !this.profileId) {
            console.warn("Cannot check availability: eventId or profileId is missing");
            return;
        }

        const data = await S25ReservationUtil.checkObjectsDatesAvailability(
            this.eventId,
            this.profileId,
            date,
            this.occ?.locations ?? [],
            this.occ?.resources ?? [],
        );
        const findLocationConflict: WSSpaceAvail[] = [];
        const findResourcesConflict: WSResourceAvail[] = [];
        const displayConflicts: AvailCheck.ConflictDefaults[] = [];

        for (const item of data) {
            if ("resources" in item) {
                findResourcesConflict.push(
                    ...item.resources.resource.filter((resource) => resource.has_conflicts === "T"),
                );
            }

            if ("spaces" in item) {
                for (const space of item.spaces.space) {
                    const locations = await S25ReservationUtil.getObjectsFlat(
                        this.occ.locations[0] as S25RmReservation,
                    );
                    const override = await S25ReservationUtil.conflictOverride(space, fls, locations);
                    if (space.has_conflicts === "T" && !override) {
                        findLocationConflict.push(space);
                    }
                }
            }
        }

        if (findLocationConflict.length) {
            displayConflicts.push(
                ...ResourceSpaceAvailService.toDisplayConflicts(
                    { spaces: { space: findLocationConflict } },
                    "space",
                    fls,
                ),
            );
        }
        if (findResourcesConflict.length) {
            displayConflicts.push(
                ...ResourceSpaceAvailService.toDisplayConflicts(
                    { resources: { resource: findResourcesConflict } },
                    "resource",
                    fls,
                ),
            );
        }

        this.findLocationConflict = findLocationConflict;
        this.findResourcesConflict = findResourcesConflict;

        this.hasConflict = findLocationConflict.length > 0 || findResourcesConflict.length > 0;

        if (this.hasConflict) {
            this.spaceConflictMessage.set(SpaceConflictErrorUtil.SAVE_BLOCKED_MESSAGE);
            this.showSpaceConflictModal(displayConflicts);
        } else {
            this.displayConflicts.set([]);
            this.hasConflict = false;
        }
        this.cd.detectChanges();
    }

    openSpaceConflictModal() {
        if (!this.displayConflicts().length) return;
        this.spaceConflictModal?.open();
    }

    private showSpaceConflictModal(conflicts: AvailCheck.ConflictDefaults[]) {
        this.displayConflicts.set(conflicts);
        this.spaceConflictModal?.open();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["mode"] || changes["profileId"] || changes["occ"]) {
            this.initCopySegmentTarget();
        }
    }

    copySegmentProfileOptions(): S25Profile[] {
        return copySegmentProfileOptions(this.occurrencesService.getProfiles());
    }

    copyRepeatPatternOnSource(): boolean {
        return this.isCopyTargetSourceSegment() && this.repeatPatternToggle && !!this.profileCode;
    }

    private initCopySegmentTarget(): void {
        if (!this.isCopyMode) {
            return;
        }
        const sourceProfileId = this.profileId ?? this.occ?.profileId;
        if (!Number.isFinite(sourceProfileId)) {
            return;
        }
        this.copySourceProfileId = sourceProfileId;
        this.copyTargetProfileKey = String(sourceProfileId);
        this.newSegmentName = "";
        this.copySegmentSaveValidationAttempted.set(false);
        this.updateCopySaveButtonDisabled();
    }

    isCopyTargetSourceSegment(): boolean {
        if (!this.isCopyMode) {
            return false;
        }
        return isCopyTargetSourceSegment(this.copyTargetProfileKey, this.copySourceProfileId);
    }

    onCopyTargetSegmentChange(): void {
        if (!this.isCopyMode) {
            return;
        }
        if (this.copyTargetProfileKey === COPY_NEW_SEGMENT_KEY) {
            this.profileCode = undefined;
            this.repeatPatternToggle = false;
            this.newOccsAvail = [];
            this.copySegmentSaveValidationAttempted.set(false);
            void this.ensureNewSegmentNameDefault();
        } else {
            const targetProfileId = S25Util.parseInt(this.copyTargetProfileKey);
            if (targetProfileId) {
                this.refreshProfileCodeForCopyTarget(targetProfileId);
            }
        }
        this.updateCopySaveButtonDisabled();
        if (this.occ.eventStart) {
            this.checkOverlapping(this.occ.eventStart);
        }
        this.cd.detectChanges();
    }

    copySegmentPatternChangeWarning(): string | undefined {
        if (!this.isCopyMode) {
            return undefined;
        }
        return copySegmentPatternChangeWarning({
            copyTargetProfileKey: this.copyTargetProfileKey,
            copySourceProfileId: this.copySourceProfileId,
            profiles: this.occurrencesService.getProfiles(),
            repeatPatternOnSource: this.copyRepeatPatternOnSource(),
        });
    }

    /** Start/end datetime picker (not repeat-through extension) in copy/add modal. */
    showOccurrenceDateTimePicker(): boolean {
        if (!this.canEdit && !this.hasPerm) {
            return false;
        }
        if (!this.isModalSaveMode) {
            return true;
        }
        if (!this.profileCode || !this.repeatPatternToggle) {
            return true;
        }
        if (this.isCopyMode && !this.isCopyTargetSourceSegment()) {
            return true;
        }
        if (this.isCopyMode && this.copySegmentPatternChangeWarning()) {
            return true;
        }
        return false;
    }

    onNewSegmentNameChange(): void {
        if (!this.isCopyMode || this.copyTargetProfileKey !== COPY_NEW_SEGMENT_KEY) {
            return;
        }
        this.copySegmentSaveValidationAttempted.set(false);
        this.updateCopySaveButtonDisabled();
        this.cd.detectChanges();
    }

    private updateCopySaveButtonDisabled(): void {
        if (!this.isCopyMode) {
            return;
        }
        if (this.copyTargetProfileKey === COPY_NEW_SEGMENT_KEY && !isNewSegmentNameValid(this.newSegmentName)) {
            this.copyOccSaveButtonDisabled = true;
            return;
        }
        if (
            this.isCopyTargetSourceSegment() &&
            this.profileCode &&
            this.repeatPatternToggle &&
            this.newOccsAvail.length === 0
        ) {
            this.copyOccSaveButtonDisabled = true;
            return;
        }
        this.copyOccSaveButtonDisabled = false;
    }

    private resolvedCopyTargetProfileId(): number | undefined {
        return resolvedCopyTargetProfileId(this.copyTargetProfileKey);
    }

    private refreshProfileCodeForCopyTarget(profileId: number): void {
        const keepRepeatOnSourceSegment = this.isCopyMode && profileId === this.copySourceProfileId;
        this.profileCode = keepRepeatOnSourceSegment
            ? S25ProfileUtil.getProfileCode(this.occurrencesService.getProfiles(), profileId)
            : undefined;
        if (!this.profileCode) {
            this.repeatPatternToggle = false;
            this.newOccsAvail = [];
            this.copyOccSaveButtonDisabled = false;
            return;
        }
        const throughDateFromCode = ProfileUtil.getProfileCodeThroughDate(this.profileCode);
        const throughDateForModel = throughDateFromCode || null;
        this.throughDate = throughDateFromCode || undefined;
        this.profileModel = ProfileUtil.getProfileModel(null, this.profileCode, throughDateForModel);
        this.patternEndChoices = this.profileModel.repeatEnd;
        this.repetitionText = EventOccUtil.getRepetitionText(this.profileCode);
        this.endsAfter = this.profileModel.endsAfter;
        this.repeatPatternToggle = true;
        this.copyOccSaveButtonDisabled = true;
    }

    hasCopyLocations(): boolean {
        return this.collectCopyObjectIds("location").length > 0;
    }

    hasCopyResources(): boolean {
        return this.collectCopyObjectIds("resource").length > 0;
    }

    removeAllCopyLocations(): void {
        if (this.mode !== "copy") {
            return;
        }
        const locationIds = this.collectCopyObjectIds("location");
        if (!locationIds.length) {
            return;
        }
        S25ReservationUtil.removeLocationsById(this.occ, locationIds);
        this.deleteWarning.set(emptyOccurrenceDeleteWarning());
        this.setShowPrivateObjsMsg();
        this.cd.detectChanges();
    }

    removeAllCopyResources(): void {
        if (this.mode !== "copy") {
            return;
        }
        const resourceIds = this.collectCopyObjectIds("resource");
        if (!resourceIds.length) {
            return;
        }
        S25ReservationUtil.removeResourceById(this.occ, resourceIds);
        this.deleteWarning.set(emptyOccurrenceDeleteWarning());
        this.setShowPrivateObjsMsg();
        this.cd.detectChanges();
    }

    private collectCopyObjectIds(objectType: "location" | "resource"): number[] {
        const objectIds = new Set<number>();
        const container =
            objectType === "location"
                ? this.occ.locations?.[0]
                : (this.occ.resources?.[0] as S25RmReservation | undefined);
        if (!container) {
            return [];
        }
        for (const rsrvType of this.objectRsrvArr) {
            const items = container[rsrvType as rsrvType];
            items?.forEach((item: S25RmReservation | S25RsReservation) => {
                if (item?.itemId != null) {
                    objectIds.add(item.itemId);
                }
            });
        }
        return [...objectIds];
    }

    private async ensureNewSegmentNameDefault(): Promise<void> {
        if (this.newSegmentName?.trim()) {
            return;
        }
        const newProfileId = await EventService.getNewProfileId();
        this.newSegmentName = `Segment_${newProfileId}`;
    }

    private buildCopyOccTargetsPreview(): CopyOccTarget[] {
        const profileId = this.resolvedCopyTargetProfileId() ?? this.copySourceProfileId ?? this.profileId;
        if (!Number.isFinite(profileId)) {
            return [];
        }
        return [
            {
                profileId: profileId!,
                rsrvId: this.occ.itemId,
                keepRepeatPattern:
                    this.repeatPatternToggle && this.profileCode !== undefined && this.isCopyTargetSourceSegment(),
            },
        ];
    }

    private async buildCopyOccTargetsForSave(): Promise<CopyOccTarget[] | undefined> {
        if (!this.isCopyMode) {
            return undefined;
        }
        let targetProfileId = this.resolvedCopyTargetProfileId();
        if (this.copyTargetProfileKey === COPY_NEW_SEGMENT_KEY) {
            const segmentName = this.newSegmentName?.trim();
            if (!isNewSegmentNameValid(segmentName)) {
                this.copySegmentSaveValidationAttempted.set(true);
                this.cd.detectChanges();
                return undefined;
            }
            const newProfileId = await EventService.getNewProfileId();
            const newProfile = await S25ProfileUtil.createEmptyProfile(
                this.occ.eventStart as Date,
                this.occ.eventEnd as Date,
                segmentName,
                newProfileId,
                "",
                RecordType.FreeForm,
            );
            this.occurrencesService.addProfile(newProfile as S25Profile);
            targetProfileId = newProfile.itemId;
        }
        if (!Number.isFinite(targetProfileId)) {
            alert("Select a segment to copy into.");
            return undefined;
        }

        return [
            {
                profileId: targetProfileId!,
                rsrvId: this.occ.itemId,
                keepRepeatPattern:
                    targetProfileId === this.copySourceProfileId &&
                    this.repeatPatternToggle &&
                    this.profileCode !== undefined,
            },
        ];
    }

    // save date changes or copy occ use event mirco service
    async save(setup?: number, takedown?: number) {
        const copyTargets = await this.buildCopyOccTargetsForSave();
        if (this.isCopyMode && !copyTargets) {
            return;
        }
        let date: any = [
            {
                startDt: this.occ?.setupStart || this.occ?.preEventStart || this.occ.eventStart,
                endDt: this.occ?.takeDownEnd || this.occ?.postEventEnd || this.occ.eventEnd,
            },
        ];

        if (setup && takedown) date = S25ObjectSearchUtil.adjustDates(date, setup, takedown);
        const data = this.normalizeSaveData(this.isDatesChanged, copyTargets);

        if (this.profileCode && this.newProfileCode && this.newOccsAvail.length > 0) {
            const currentProfile = data.items[0].profiles[0];
            currentProfile.occurrenceDefn.profileCode = this.newProfileCode;
            const firstRsrv: WSReservations = currentProfile.reservations[0];
            await this.setAdditionalNewOccs(currentProfile, firstRsrv);
        }

        await this.checkObjectsAvailability(date, this.fls!);

        if (!this.hasConflict) {
            const occurrenceDefn = data?.items?.[0]?.profiles?.[0]?.occurrenceDefn;

            if (setup && takedown && occurrenceDefn) {
                // Preserve original initStartDt/initEndDt — layout change should not alter profile date boundaries
                const originalProfile = this.occurrencesService
                    .S25Event()
                    ?.profile?.find((p) => p.itemId === this.profileId);
                if (originalProfile?.occurrenceDefn) {
                    occurrenceDefn.initStartDt = originalProfile.occurrenceDefn.initStartDt;
                    occurrenceDefn.initEndDt = originalProfile.occurrenceDefn.initEndDt;
                }

                occurrenceDefn.addedTime = {
                    setup: S25Util.minutesToISODuration(setup),
                    takedown: S25Util.minutesToISODuration(takedown),
                };
            }

            this.setLoading(true);

            TelemetryService.sendWithSub(
                "EventDetails",
                "EventDetailsOcc",
                this.mode === "add" ? "AddOccurrence" : this.mode === "copy" ? "OccCopy" : "EditMode",
            );
            const [ok, error] = await S25Util.Maybe(
                this.occurrencesService.runInlineEditScenarios(this.eventId!, () =>
                    EventMicroService.microPutEventDetail(data, this.eventId!),
                ),
            );
            this.setLoading(false);
            if (ok) {
                if (ok?.content?.errors || ok?.content?.messages) {
                    for (const error of ok?.content?.errors || ok?.content?.messages) {
                        NotificationService.post(error.message);
                    }
                } else {
                    if (setup && takedown) {
                        this.occ!.setupStart = S25Util.date.addMinutes(this.occ!.eventStart, -setup);
                        this.occ!.takeDownEnd = S25Util.date.addMinutes(this.occ!.eventEnd, takedown);
                        // Update via service method (triggers signal reactivity)
                        this.occurrencesService.updateProfileAddedTime(this.profileId!, {
                            setup: S25Util.minutesToISODuration(setup),
                            takedown: S25Util.minutesToISODuration(takedown),
                        });
                    }

                    this.initSlider = false; // reset slider
                    this.cd.detectChanges();
                    const movedFromWaitlist = this.isDatesChanged ? await this.removeStaleWaitlistEntries() : false;
                    if (movedFromWaitlist) {
                        await this.occurrencesService.getEvent(this.eventId!, true);
                    } else {
                        await this.occurrencesService.getEvent(this.eventId!, false, ok);
                    }
                    this.syncOccFromService();
                    this.isDatesChanged = false;
                    this.isOverlap.set(false);
                    this.setSliderRange();
                    this.initSlider = true;
                    this.cd.detectChanges();
                    this.refreshF.emit();
                }
                if (this.isModalSaveMode) this.onSave.emit();
            }

            if (error) {
                if (
                    await this.showSpaceConflictFromPutError(error, [
                        {
                            startDt: this.occ?.setupStart || this.occ?.preEventStart || this.occ.eventStart,
                            endDt: this.occ?.takeDownEnd || this.occ?.postEventEnd || this.occ.eventEnd,
                        },
                    ])
                ) {
                    return;
                }
                return S25Util.showError(error, "There was an error while attempting to copy this reservation.");
            }
        }
    }

    findDuplicateOcc(occList: WSReservations[]) {
        if (
            (this.isModalSaveMode && !this.profileCode) ||
            (this.isModalSaveMode && this.profileCode && !this.repeatPatternToggle)
        ) {
            const getOccList = [...this.occurrencesService.getOccurrences(), this.occ];
            occList = S25ProfileUtil.normalizeRsrvWSData(getOccList, RecordType.FreeForm);
        }
        const eventStartSet = new Set();
        const duplicates: string[] = [];
        occList.forEach((event) => {
            const eventStart = S25Util.date.toS25ISODateTimeStr(event.evStartDt);
            if (eventStartSet.has(eventStart)) {
                duplicates.push(eventStart);
            } else {
                eventStartSet.add(eventStart);
            }
        });
        return duplicates;
    }

    findExistingOccurrence(occurrencesList: S25Reservation[]) {
        return occurrencesList.find(
            (item) =>
                S25Util.date.toS25ISODateTimeStr(item.eventStart) ===
                S25Util.date.toS25ISODateTimeStr(this.occ.eventStart),
        );
    }

    hasDuplicateDate(findOcc: S25Reservation) {
        const isSameStartDate =
            S25Util.date.toS25ISODateTimeStr(this.occ.eventStart) ===
            S25Util.date.toS25ISODateTimeStr(this.initOcc.eventStart);
        if (isSameStartDate) return true;
        if (findOcc) return !this.isModalSaveMode || this.occ.itemId === findOcc.itemId;
    }

    cancel() {
        this.init = false;
        delete this.occ;
        this.cd.detectChanges();
        this.occ = this.initOcc;
        this.setSliderRange();
        this.init = true;
        this.cd.detectChanges();
        if (this.isModalSaveMode) this.onCancel.emit();
    }

    isConflict(id: number, type: string) {
        if (type === "location") {
            const find = this.findLocationConflict.find((f: any) => {
                return f && f.space_id === id;
            });
            return find;
        } else {
            const find = this.findResourcesConflict.find((f: any) => {
                return f && f.resource_id === id;
            });
            return find;
        }
    }

    setSliderRange() {
        this.zone.run(() => {
            const timeLabels = OccurrenceTimeRangeLabels;
            this.sliderRange = [
                {
                    start: this.occ.eventStart,
                    end: this.occ.eventEnd,
                    startLabel: timeLabels.event.start,
                    endLabel: timeLabels.event.end,
                    hideStart: false,
                    hideEnd: false,
                },
            ];

            if (this.occ.preEventStart || this.occ.postEventEnd) {
                this.sliderRange.push({
                    start: this.occ?.preEventStart || this.occ.eventStart,
                    end: this.occ?.postEventEnd || this.occ.eventEnd,
                    startLabel: timeLabels.prePost.start,
                    endLabel: timeLabels.prePost.end,
                    hideStart: !this.occ.preEventStart || this.isSameTime(this.occ.preEventStart, this.occ.eventStart),
                    hideEnd: !this.occ.postEventEnd || this.isSameTime(this.occ.postEventEnd, this.occ.eventEnd),
                });
            }

            if (this.occ.setupStart || this.occ.takeDownEnd) {
                this.sliderRange.push({
                    start: this.occ?.setupStart || this.occ.preEventStart || this.occ.eventStart,
                    end: this.occ?.takeDownEnd || this.occ.postEventEnd || this.occ.eventEnd,
                    startLabel: timeLabels.setupTakedown.start,
                    endLabel: timeLabels.setupTakedown.end,
                    hideStart: !this.occ.setupStart || this.isSameTime(this.occ.setupStart, this.occ.eventStart),
                    hideEnd: !this.occ.takeDownEnd || this.isSameTime(this.occ.takeDownEnd, this.occ.eventEnd),
                });
            }

            this.initSliderRange = S25Util.deepCopy(this.sliderRange);
        });
    }

    isSameTime(a: Date, b: Date): boolean {
        return a?.getTime?.() === b?.getTime?.();
    }

    // update Ojbect uses  Reservation Micro  service
    async updateObject(updateItem: any, type: rsrvType, itemTypeId: number) {
        const event = this.occurrencesService.S25Event();
        const reservations: any[] = [];

        if (itemTypeId === Item.Ids.Location) {
            for (const item of this.selectedReservationIds()) {
                //check if rsrv has the update object
                const find = await S25ReservationUtil.getObjectRsrvId(event!, item, updateItem.itemId, itemTypeId);
                if (find)
                    reservations.push({
                        rsrvId: item, //rsrvId
                        spaces: [
                            {
                                [type]: [
                                    {
                                        spaceId: updateItem.itemId,
                                        layoutId: updateItem?.layout?.itemId,
                                        share: updateItem.isShare,
                                        instructions: updateItem.instructions,
                                        rating: updateItem.rating,
                                        attendance: updateItem.attendance,
                                    },
                                ],
                            },
                        ],
                    });
            }
        } else {
            for (const item of this.selectedReservationIds()) {
                const find = await S25ReservationUtil.getObjectRsrvId(event!, item, updateItem.itemId, itemTypeId);
                if (find)
                    reservations.push({
                        rsrvId: item, //rsrvId
                        resources: [
                            {
                                [type]: [
                                    {
                                        resourceId: updateItem.itemId,
                                        quantity: updateItem.quantity,
                                        instructions: updateItem.instructions,
                                    },
                                ],
                            },
                        ],
                    });
            }
        }
        const payload = this.buildInlineEditPayload(reservations);
        const [, error] = await this.runInlineReservationSave(payload);

        if (error) {
            const selectedReservations = this.occurrencesService
                .getOccurrences()
                .filter((rsrv) => this.selectedItems?.includes(rsrv.itemId) || rsrv.itemId === this.occ.itemId);
            if (
                await this.showSpaceConflictFromPutError(
                    error,
                    S25ReservationUtil.getReservationsStartEndDates(selectedReservations),
                )
            ) {
                return;
            }
            return S25Util.showError(error, "There was an error while attempting to update this reservation.");
        }
    }

    /** ANG-7691: shared PUT space-conflict → Conflicts modal path. */
    private async showSpaceConflictFromPutError(
        error: unknown,
        dates: { startDt: Date; endDt: Date }[],
    ): Promise<boolean> {
        const locations = S25ReservationUtil.getObjectsFlat(this.occ.locations?.[0] as S25RmReservation);
        const parsed = SpaceConflictErrorUtil.parsePutError(error, locations);
        if (!parsed) return false;

        this.hasConflict = true;
        this.spaceConflictMessage.set(parsed.summary);
        this.showSpaceConflictModal(parsed.conflicts);
        this.displayConflicts.set(
            await SpaceConflictErrorUtil.enrichWithAvailTimes(parsed.conflicts, {
                dates,
                eventId: this.eventId,
                profileId: this.profileId,
                fls: this.fls,
            }),
        );
        this.cd.detectChanges();
        return true;
    }

    setLoading(yes: boolean) {
        const target = this.isModalSaveMode
            ? this.actionLoadingSpinner?.nativeElement
            : this.rowLoadingSpinner?.nativeElement;
        if (!target) {
            return;
        }
        if (yes) {
            S25LoadingApi.init(target);
            if (this.isModalSaveMode) {
                target.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
        } else {
            S25LoadingApi.destroy(target);
        }
        this.saving.set(yes);
        this.cd.detectChanges();
    }

    async promptRemoveLocation(
        itemName: string,
        objType: "space" | "resource",
        index: number,
        rsrvType: rsrvType | "waitlist",
    ): Promise<void> {
        if (
            objType === "space" &&
            !this.isModalSaveMode &&
            this.eventId != null &&
            !(await confirmBoundEventLocationChangeForOccurrence(
                "remove",
                this.eventId,
                this.profileId,
                getProfileReservationsForBoundLocationPrompt(this.occurrencesService.S25Event(), this.profileId),
                this.selectedReservationIds(),
            ))
        ) {
            return;
        }
        if (this.mode === "copy" && rsrvType !== "waitlist") {
            this.removeCopyObjectWithoutConfirm(objType, index, rsrvType);
            return;
        }
        this.setConfirmDeleteMsg(itemName, objType, index, rsrvType);
    }

    setConfirmDeleteMsg(
        itemName: string,
        objType: "space" | "resource",
        index: number,
        rsrvType: rsrvType | "waitlist",
    ) {
        if (this.mode === "copy" && rsrvType !== "waitlist") {
            this.removeCopyObjectWithoutConfirm(objType, index, rsrvType);
            return;
        }
        let affectedOccs = [];
        if (this.selectedItems?.length) {
            const occData: any = { dateFormat: this.dateFormat, timeFormat: this.timeFormat };
            const occs = this.occurrencesService.getOccurrences();
            const massagedOccs = this.selectedItems
                ?.map((rsrvId) => {
                    const occMatch = occs?.find((occ) => occ.itemId === rsrvId);
                    if (occMatch) {
                        occData[rsrvId] = {
                            rsrvStartDt: occMatch.eventStart,
                            rsrvEndDt: occMatch.eventEnd,
                        };
                        return { occurrence: occMatch.eventStart, rsrvId: rsrvId };
                    }
                })
                ?.filter(Boolean);
            S25PricingUtil.formatOccDates(massagedOccs as any, occData);
            affectedOccs = massagedOccs?.map((occ) => occ.occurrence);
        } else {
            affectedOccs.push(S25Datefilter.transform(this.occ.eventStart, this.dateFormat));
        }

        // Different message for waitlist vs regular occurrences
        const msg =
            rsrvType === "waitlist"
                ? `Are you sure you want to remove ${itemName} from waitlist?`
                : `Are you sure you want to remove ${itemName} from these occurrences?`;

        this.deleteWarning.set({
            index: index,
            msg: msg,
            listItems: affectedOccs,
            objType: objType,
            rsrvType: rsrvType,
        });
    }

    ngOnDestroy() {
        if (this.selectedItemsSubscription) {
            this.selectedItemsSubscription?.unsubscribe();
        }
    }

    onCopyOccObjectDelete(type: ObjectType, id: number, confirmed: boolean) {
        this.deleteWarning.set(emptyOccurrenceDeleteWarning());
        if (!confirmed) return;
        type === "location"
            ? S25ReservationUtil.removeLocationsById(this.occ, [id])
            : S25ReservationUtil.removeResourceById(this.occ, [id]);

        this.setShowPrivateObjsMsg();

        this.cd.detectChanges();
    }

    private removeCopyObjectWithoutConfirm(objType: "space" | "resource", index: number, rsrvType: rsrvType): void {
        const container = objType === "space" ? this.occ.locations?.[0] : this.occ.resources?.[0];
        const item = container?.[rsrvType]?.[index];
        if (!item?.itemId) {
            return;
        }
        this.onCopyOccObjectDelete(objType === "space" ? "location" : "resource", item.itemId, true);
    }

    onObjectSearch(itemTypeId: Item.Ids) {
        this.objectSearchEvent = this.buildObjectSearchEvent();
        this.objectSearchItemTypeId = itemTypeId;
        this.objectSearchModal?.open();
    }

    private buildObjectSearchEvent(): S25Event | undefined {
        const event = this.occurrencesService.S25Event();
        if (!event || !this.profileId || !this.occ) {
            return event;
        }

        const profile = S25ProfileUtil.getProfileByProfileId(event.profile ?? [], this.profileId);
        if (!profile) {
            return event;
        }

        const reservations = (profile.reservations ?? []) as S25Reservation[];
        const alreadyIncluded = reservations.some((rsrv) => rsrv.itemId === this.occ.itemId);
        if (alreadyIncluded) {
            return event;
        }

        const updatedProfile: S25Profile = {
            ...profile,
            reservations: [...reservations, this.occ],
        };

        return {
            ...event,
            profile: (event.profile ?? []).map((profileEntry) =>
                profileEntry.itemId === this.profileId ? updatedProfile : profileEntry,
            ),
        };
    }

    async onObjectSearchRefresh(output: ObjectSearchRefresh) {
        if (this.objectSearchItemTypeId === Item.Ids.Resource) {
            const resources =
                output.items?.map((resource: ObjectSearchAvail.AddedResource) => ({
                    itemId: resource.resourceId,
                    itemName: resource.resourceName ?? "",
                    quantity: resource.quantity,
                    instructions: resource.instructions,
                    hasPerm: !S25Util.isPrivate(resource.resourceName ?? ""),
                })) ?? [];
            this.mergeResources(resources);
        } else {
            if (
                this.eventId != null &&
                !(await confirmBoundEventLocationChangeForOccurrence(
                    "add",
                    this.eventId,
                    this.profileId,
                    getProfileReservationsForBoundLocationPrompt(this.occurrencesService.S25Event(), this.profileId),
                    this.selectedReservationIds(),
                ))
            ) {
                this.objectSearchComponent?.searchResultsList()?.revertPendingAddButtons(output.items);
                return;
            }
            const locations =
                output.items?.map((location: ObjectSearchAvail.AddedLocation) =>
                    normalizeLocationFromObjectSearch({
                        itemId: location.spaceId,
                        itemName: location.spaceName ?? "",
                        isShare: location.share,
                        layouts: location.layouts,
                        maxCapacity: location.maxCapacity,
                        instructions: location.instructions,
                        hasPerm: !S25Util.isPrivate(location.spaceName ?? ""),
                    }),
                ) ?? [];
            this.mergeLocations(locations);
        }

        this.setShowPrivateObjsMsg();
        this.objectSearchModal?.close();
        this.cd.detectChanges();
    }

    private mergeLocations(locations: S25RmReservation[]) {
        this.mergeOccReserved(this.occ.locations, locations, (container) => {
            this.occ.locations = [container];
        });
    }

    private mergeResources(resources: S25RsReservation[]) {
        this.mergeOccReserved(this.occ.resources, resources, (container) => {
            this.occ.resources = [container];
        });
    }

    setSearchButtons() {
        const occState = this.occ?.state;
        const spaceSearch = this.fls?.SPACE_SEARCH;
        const resourceSearch = this.fls?.RESOURCE_SEARCH;
        this.locSearchDisabled =
            occState === 99 || occState === 2 || !(spaceSearch && ["F", "R", "C"].indexOf(spaceSearch) > -1);
        this.resSearchDisabled =
            occState === 99 || occState === 2 || !(resourceSearch && ["F", "R", "C"].indexOf(resourceSearch) > -1);
    }

    setShowPrivateObjsMsg() {
        const hasPermCopy = S25ReservationUtil.checkObjHasPerm(S25Util.array.forceArray(this.occ));
        this.showPrivateObjsMsg.set(!hasPermCopy);
    }

    async onOccCommentsChange(newVal: string) {
        if (this.isModalSaveMode) return false;
        const reservations = this.selectedReservationIds().map((rsrvId) => ({
            rsrvId,
            comments: newVal,
        }));
        const payload = this.buildInlineEditPayload(reservations);
        const [, error] = await this.runInlineReservationSave(payload, { refresh: "always" });
        if (error) return S25Util.showError(error, "There was an error while attempting to update this reservation.");
    }

    checkOverlapping(newDate: Date) {
        if (this.profileCode && this.repeatPatternToggle) return;
        if (this.isCopyMode) {
            this.isOverlap.set(this.copyWouldOverlapAtDate(newDate));
            this.cd.detectChanges();
            return;
        }
        const data = this.normalizeSaveData(this.isDatesChanged);
        const rsrvs: WSReservations[] = data.items[0].profiles[0].reservations as WSReservations[];
        const duplicates: string[] = this.findDuplicateOcc(rsrvs);
        const newDateDuplicates = duplicates.find(
            (item) => S25Util.date.toS25ISODateTimeStr(item) === S25Util.date.toS25ISODateTimeStr(newDate),
        );
        this.isOverlap.set(newDateDuplicates ? true : false);
        this.cd.detectChanges();
    }

    private copyWouldOverlapAtDate(date: Date): boolean {
        const compareStart = S25Util.date.toS25ISODateTimeStr(date);
        const targetProfileId = this.resolvedCopyTargetProfileId();
        if (this.copyTargetProfileKey === COPY_NEW_SEGMENT_KEY) {
            return false;
        }

        return this.occurrencesService.getOccurrences().some((rsrv) => {
            if (rsrv.itemId === this.occ.itemId) {
                return false;
            }
            if (targetProfileId != null && rsrv.profileId != null && rsrv.profileId !== targetProfileId) {
                return false;
            }
            return S25Util.date.toS25ISODateTimeStr(rsrv.eventStart) === compareStart;
        });
    }

    normalizeSaveData(isDatesChanged: boolean, copyTargets?: CopyOccTarget[]) {
        const event = S25Util.clone(this.occurrencesService.S25Event());
        if (this.isCopyMode) {
            const targets = copyTargets ?? this.buildCopyOccTargetsPreview();
            return EventOccUtil.normalizeCopyEventWSData(event, this.occ, targets[0], isDatesChanged)[0].data;
        }
        const keepRepeatPattern: boolean = this.repeatPatternToggle && this.profileCode !== undefined;
        const normalizeSaveData = EventOccUtil.normalizeEventWSData(
            event,
            this.occ,
            this.isModalSaveMode,
            false,
            isDatesChanged,
            keepRepeatPattern,
        );
        return normalizeSaveData[0].data;
    }

    onSharedChange(newVal: boolean, type?: rsrvType, index?: number) {
        this.occ.locations[0][type][index].isShare = newVal;
        if (this.isModalSaveMode) return false;
        const updateItem = this.occ.locations[0][type][index];
        this.updateObject(updateItem, type, Item.Ids.Location);
    }

    async profileModelChange(patternEndChoices: string) {
        const existingOccs: S25Reservation[] = await this.getProfileOccs();
        const tempProfileModel = S25Util.clone(this.profileModel);
        if (patternEndChoices === "date") {
            if (S25Util.date.parse(this.profileModel.throughDate) >= S25Util.date.parse(this.throughDate)) {
                alert(
                    "Please choose a date greater than the initial through date of " +
                        S25Datefilter.transform(tempProfileModel.throughDate, this.dateFormat) +
                        ".",
                );
                return;
            } else {
                tempProfileModel.throughDate = this.throughDate;
            }
        }

        if (patternEndChoices === "iterations") tempProfileModel.endsAfter = this.endsAfter;
        this.newProfileCode = await ProfileUtil.getProfileCodeByModel(tempProfileModel);
        // get new Profile Code getOccurrences
        const newOccList = ProfileUtil.getOccurrences(
            { evStartDt: existingOccs[0].eventStart, evEndDt: existingOccs[0].eventEnd }, //  start and end of  1st segment  rsrv
            tempProfileModel,
        );

        // filter new Profile Code getOccurrences, already existed
        this.newOccsAvail = newOccList.filter(
            (newOcc) =>
                !existingOccs.some(
                    (existingOcc) =>
                        S25Util.date.toS25ISODateStr(existingOcc.eventStart) ===
                            S25Util.date.toS25ISODateStr(newOcc.evStartDt) &&
                        S25Util.date.toS25ISODateStr(existingOcc.eventEnd) ===
                            S25Util.date.toS25ISODateStr(newOcc.evEndDt),
                ),
        );

        if (this.newOccsAvail.length > 0) {
            this.copyOccSaveButtonDisabled = false;
            this.onChangeDate(this.newOccsAvail[0].evStartDt, "start"); // set 1st start date change newOcc
            this.onChangeDate(this.newOccsAvail[0].evEndDt, "end"); // set  1st end date newOcc
        } else {
            this.copyOccSaveButtonDisabled = true;
            this.cd.detectChanges();
        }
    }

    async getProfileOccs() {
        const occs = this.occurrencesService.getOccurrences();
        const profileOccs: S25Reservation[] = await S25ProfileUtil.getProfileReservationsByProfileId(
            occs,
            this.occ.profileId ?? 0,
        );
        return profileOccs;
    }

    async setAdditionalNewOccs(currentProfile: S25Profile, firstRsrv: WSReservations) {
        const newRsrvId: any = await ReservationService.generateReservationIds(this.newOccsAvail.length);
        let count = 0;
        // Start from the second item of newOccAvail (index 1), 1st one already set when changed iternation or thruDate
        for (const avail of this.newOccsAvail.slice(1)) {
            count++;
            const newReservation = {
                rsrvId: newRsrvId.idSet[count].rsrvId,
                comments: firstRsrv.comments,
                state: firstRsrv.state,
                occurrence: S25Util.date.toS25ISODateStr(avail.evStartDt),
                evStartDt: S25Util.date.toS25ISODateTimeStr(
                    S25Util.date.copyYearMonthDay(avail.evStartDt, new Date(firstRsrv.evStartDt)),
                ),
                evEndDt: S25Util.date.toS25ISODateTimeStr(
                    S25Util.date.copyYearMonthDay(avail.evEndDt, new Date(firstRsrv.evEndDt)),
                ),
                spaces: firstRsrv.spaces,
                resources: firstRsrv.resources,
            };
            currentProfile?.reservations?.push(newReservation); // Push the new reservation to the array
        }
    }

    async onToggleChange($event: boolean) {
        this.repeatPatternToggle = $event;
        this.showRepeatPatternWarmingMsg = false;
        if (!$event) {
            this.checkOverlapping(this.occ.eventStart);
        }
        this.updateCopySaveButtonDisabled();
        this.cd.detectChanges();
    }

    layoutTimesChange($event: { takedown: string; setup: string; confirmed: boolean }): void {
        this.layoutConflictModal?.close();

        // No pending context → nothing to do
        const ctx = this.pendingLayoutContext;
        if (!ctx) return;

        const { index, type, originalLayoutId, originalLayoutName, findLayout } = ctx;
        // Safely resolve reservation item
        const occ = this.occ;
        const locationContainer = occ?.locations?.[0];
        const item = locationContainer?.[type]?.[index];

        if (!occ || !locationContainer || !item || !item.layout) {
            this.pendingLayoutContext = undefined;
            return;
        }

        if (!$event.confirmed) {
            if (originalLayoutId != null) item.layout.itemId = originalLayoutId;
            if (originalLayoutName != null) item.layout.itemName = originalLayoutName;

            this.pendingLayoutContext = undefined;
            this.cd.detectChanges();
            return;
        }

        // Update layout definition with adjusted times
        if (findLayout) {
            findLayout.layout_setup_tm = $event.setup;
            findLayout.layout_tdown_tm = $event.takedown;
        }

        // Clear context BEFORE re-running logic
        this.pendingLayoutContext = undefined;

        // Create a synthetic event compatible with onLayoutChange()
        const syntheticEvent = {
            target: {
                value: String(item.layout.itemId),
                selectedOptions: [{ text: item.layout.itemName }],
            },
        } as unknown as Event;

        // Re-run layout change logic (user edited times)
        this.onLayoutChange(syntheticEvent, index, type);
    }

    async onWaitlistDelete(entry: WaitlistEntry, confirmed: boolean) {
        this.deleteWarning.set(emptyOccurrenceDeleteWarning());
        if (!confirmed) return;
        if (!entry.waitlistId) return;

        this.setLoading(true);
        const [ok, error] = await S25Util.Maybe(
            this.waitlistStore.deleteWaitlistEntry(entry.waitlistId, entry, this.occ.itemId),
        );
        this.setLoading(false);

        if (error) {
            return S25Util.showError(error, "There was an error while attempting to remove this waitlist entry.");
        }

        // comment out for now
        // await TaskCompetingUtil.assignNextWaitlistEntry(entry, this.occ.itemId);

        // Remove from local occ data
        if (this.occ?.waitlistRsrvEntries) {
            this.occ.waitlistRsrvEntries = this.occ.waitlistRsrvEntries.filter(
                (e) => e.waitlistId !== entry.waitlistId,
            );

            this.getLocationWaiting();
        }

        // Force reload: fetchWaitlistEntriesForEvent(false) uses WaitlistStore cache, which can
        await this.occurrencesService.getEvent(this.eventId!, true);
        this.syncOccFromService();
        this.cd.detectChanges();
        this.refreshF.emit();
    }

    getWaitlistEntriesForLocation(spaceId: number | string): WaitingEntry[] {
        const occStart = this.occ?.eventStart;
        const occEnd = this.occ?.eventEnd;

        if (!occStart || !occEnd) {
            return (this.occ?.waitlistEntries ?? [])
                .filter((e) => Number(e.spaceId) === Number(spaceId))
                .flatMap((e) => e.waiting ?? []);
        }

        return (this.occ?.waitlistEntries ?? [])
            .filter((entry) => Number(entry.spaceId) === Number(spaceId))
            .flatMap((entry) =>
                (entry.waiting ?? []).filter((w) => {
                    const waitStart = new Date(w.startDt);
                    const waitEnd = new Date(w.endDt);

                    // Check for time overlap: waitStart < occEnd && occStart < waitEnd
                    return waitStart < occEnd && occStart < waitEnd;
                }),
            );
    }

    getWaitlistGroupsForLocation(spaceId: number | string): WaitlistEntry[] {
        const occStart = this.occ?.eventStart;
        const occEnd = this.occ?.eventEnd;
        const entries = (this.occ?.waitlistEntries ?? []).filter((entry) => Number(entry.spaceId) === Number(spaceId));

        if (!occStart || !occEnd) return entries;

        return entries.filter((entry) =>
            (entry.waiting ?? []).some((waiting) => {
                const waitStart = new Date(waiting.startDt);
                const waitEnd = new Date(waiting.endDt);
                return waitStart < occEnd && occStart < waitEnd;
            }),
        );
    }

    openWaitlistDetail(
        waitlistId: number | null | undefined,
        groupKey: string | null | undefined,
        locationName?: string,
        locationId?: number,
    ) {
        if (waitlistId != null) {
            this.selectedWaitlistId.set(waitlistId);
            this.selectedWaitlistGroupKey.set(undefined);
        } else if (groupKey) {
            this.selectedWaitlistId.set(undefined);
            this.selectedWaitlistGroupKey.set(groupKey);
        } else {
            return;
        }
        this.selectedWaitlistSpaceId.set(locationId);
        this.selectedWaitlistStartDt.set(this.occ?.eventStart);
        this.selectedWaitlistSpaceName.set(locationName ?? "");
        this.waitlistDetailModal?.open();
    }

    //  occurrrance's day/time changed and it's no longer a waitlist, removed from waitlist
    private async removeStaleWaitlistEntries(): Promise<boolean> {
        const occStart = this.occ?.eventStart;
        const occEnd = this.occ?.eventEnd;
        if (!occStart || !occEnd || !this.occ?.waitlistRsrvEntries?.length) return false;

        const staleEntries = this.occ.waitlistRsrvEntries.filter(
            (entry) =>
                !entry.waiting?.some((w) => {
                    const waitStart = new Date(w.startDt);
                    const waitEnd = new Date(w.endDt);
                    return waitStart < occEnd && occStart < waitEnd;
                }),
        );

        if (!staleEntries.length) return false;

        this.setLoading(true);
        const removedEntries: WaitlistEntry[] = [];
        for (const entry of staleEntries) {
            const added = await this.addWaitlistLocationToOccurrence(entry.spaceId);
            if (!added) continue;
            await this.waitlistStore.deleteWaitlistEntry(entry.waitlistId!, entry, this.occ.itemId);
            removedEntries.push(entry);
        }
        this.setLoading(false);

        if (removedEntries.length > 0) {
            this.occ.waitlistRsrvEntries = this.occ.waitlistRsrvEntries.filter(
                (e) => !removedEntries.some((s) => s.waitlistId === e.waitlistId),
            );
            this.getLocationWaiting();
        }

        return removedEntries.length > 0;
    }

    // occurrrance's day/time changed and it's no longer a waitlist, request/assign waitlist location to reservations
    private async addWaitlistLocationToOccurrence(spaceId: number): Promise<boolean> {
        const payload: EventDataMicroI = {
            items: [
                {
                    kind: "event",
                    id: this.eventId,
                    profiles: [
                        {
                            profileId: this.profileId,
                            reservations: [
                                {
                                    rsrvId: this.occ.itemId,
                                    spaces: [{ space_id: spaceId } as S25RmReservation],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        const [ok, error] = await S25Util.Maybe(
            this.occurrencesService.runInlineEditScenarios(this.eventId!, () =>
                EventMicroService.putEventReservation(this.eventId!, payload),
            ),
        );
        if (error) {
            S25Util.showError(error, "There was an error while attempting to add the waitlisted location.");
            return false;
        }

        if (ok?.content?.errors) {
            for (const err of ok.content.errors) {
                NotificationService.post(err.message);
            }
            return false;
        } else {
            await this.occurrencesService.getEvent(this.eventId!, false, ok);
            this.syncOccFromService();
            this.cd.detectChanges();
            this.refreshF.emit();
        }

        return true;
    }

    private syncOccFromService() {
        const updatedOcc = this.occurrencesService.getOccurrences().find((o) => o.itemId === this.occ.itemId);
        if (updatedOcc) {
            this.occ = updatedOcc;
            this.getLocationWaiting();
            if (this.fls) {
                void this.loadWaitlistFls(this.fls).then(() => this.cd.detectChanges());
            }
        }
    }

    getLocationWaiting() {
        const requestedIds = new Set(this.occ?.locations?.[0]?.requested?.map((loc) => loc.itemId));
        const occStart = this.occ?.eventStart;
        const occEnd = this.occ?.eventEnd;

        const entries =
            this.occ?.waitlistRsrvEntries?.filter((e) => {
                if (requestedIds.has(e.spaceId)) return false;
                if (!occStart || !occEnd) return true;
                return e.waiting?.some((w) => {
                    const waitStart = new Date(w.startDt);
                    const waitEnd = new Date(w.endDt);
                    return waitStart < occEnd && occStart < waitEnd;
                });
            }) ?? [];

        this.locationWaiting.set(entries);
    }

    // location has event/location waitlist, then check perm to see waitlist modal
    private async loadWaitlistFls(fls: Fls) {
        const locationIds = new Set<number>();
        const locations = this.occ?.locations?.[0];
        if (locations) {
            for (const arr of this.objectRsrvArr) {
                locations[arr as rsrvType]?.forEach((l) => {
                    if (l.itemId) locationIds.add(l.itemId);
                });
            }
        }
        this.locationWaiting().forEach((r) => {
            if (r.spaceId) locationIds.add(r.spaceId);
        });
        (this.occ?.waitlistEntries ?? []).forEach((entry) => {
            if (entry.spaceId) locationIds.add(entry.spaceId);
        });

        const [waitlistFlsMap, isOwner, spaces] = await Promise.all([
            TaskCompetingUtil.hasWaitlistFls(fls, Array.from(locationIds)),
            this.eventId ? EventService.isCurrentScheduler(this.eventId) : Promise.resolve(false),
            locationIds.size > 0 ? SpaceService.getSpacesMinimal(Array.from(locationIds)) : Promise.resolve([]),
        ]);
        this.waitlistFlsMap = waitlistFlsMap;
        this.isEventOwner = isOwner;
        this.locationWaitlistMap = new Map(
            spaces.map((space) => [S25Util.parseInt(space.space_id), space.waitlist ?? ""]),
        );
    }

    isLocationWaitlistEnabled(locationId: number): boolean {
        return !!this.locationWaitlistMap.get(locationId);
    }

    hasWaitlistFlsFor(locationId: number): boolean {
        return (this.waitlistFlsMap.get(locationId) ?? false) && (this.canEdit || this.isEventOwner);
    }
}
